/**
 * Where somebody is in first-run onboarding (/welcome), per person per space.
 *
 * `{ state, step, kind }`: state is 'skipped' or 'done' once they leave it,
 * absent while it is still to do; step and kind are the last screen reached, so
 * "Finish setting up" on Home reopens it where it stopped.
 *
 * PER SPACE, because the question is "is there anything built HERE". A person
 * who finished it in Personal and then makes an empty group has not built
 * anything in that group.
 *
 * NEVER THE TOKEN. A token is shown once and lives in memory only; what is
 * kept here is a screen number.
 *
 * STORAGE CAN THROW (private windows, blocked site data). `readOnboarding`
 * answers null then, and Home reads null as "do not redirect": a portal you
 * cannot leave the welcome screen of is worse than one with no welcome.
 */

export const STEPS = 4;

const key = (userId, groupId) => `dev:onboarding:${userId}:${groupId || 'personal'}`;

/** The stored record ({} when there is none), or null when storage is unusable. */
export function readOnboarding(userId, groupId) {
  if (userId == null) return null;
  try {
    const raw = localStorage.getItem(key(userId, groupId));
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return null;
  }
}

/** Merge into the stored record. A failed write is dropped, never thrown. */
export function writeOnboarding(userId, groupId, patch) {
  if (userId == null) return;
  try {
    const prev = readOnboarding(userId, groupId) || {};
    localStorage.setItem(key(userId, groupId), JSON.stringify({ ...prev, ...patch }));
  } catch { /* fail open: onboarding is a courtesy */ }
}
